import { styled } from 'styled-components';

export const AvatarHolder = styled.div`
  border-radius: 100%;
  display: flex;
  width: max-content;
  background: white;
`;
